import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { SkeletonRegion, useStableKeys } from './_shared'

export interface DetailSkeletonProps {
	lines?: number
	withHeader?: boolean
	withMedia?: boolean
	className?: string
	label?: string | false
}

const LINE_WIDTHS = ['w-full', 'w-11/12', 'w-4/5', 'w-3/4', 'w-5/6', 'w-2/3']

export function DetailSkeleton({
	lines = 8,
	withHeader = false,
	withMedia = false,
	className,
	label = 'Loading',
}: DetailSkeletonProps) {
	const keys = useStableKeys(lines)
	return (
		<SkeletonRegion label={label} className={cn('space-y-3', className)}>
			{withHeader ? (
				<div className='space-y-2'>
					<Skeleton className='h-6 w-1/3' />
					<Skeleton className='h-4 w-1/2' />
				</div>
			) : null}
			{withMedia ? <Skeleton className='h-40 w-full rounded-lg' /> : null}
			<div className='space-y-2'>
				{keys.map((key, i) => (
					<Skeleton key={key} className={cn('h-4', LINE_WIDTHS[i % LINE_WIDTHS.length])} />
				))}
			</div>
		</SkeletonRegion>
	)
}
